import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/i18n";
import { Video } from "lucide-react";

const STYLE = {
  superadmin: "bg-brand-blue hover:bg-brand-blue/90",
  academic_director: "bg-brand-orange hover:bg-brand-orange/90",
};

/** One-on-one meeting rooms (Admin / Academic direction) shown in the top bar.
 *  The link comes from each staff member's own profile (Meet or Zoom). */
export default function MeetingRoomButtons() {
  const { t } = useI18n();
  const [rooms, setRooms] = useState([]);

  useEffect(() => {
    api.get("/meeting-rooms").then((r) => setRooms(r.data || [])).catch(() => setRooms([]));
  }, []);

  if (!rooms.length) return null;

  return (
    <div className="flex items-center gap-2" data-testid="meeting-rooms">
      {rooms.map((r) => (
        <a
          key={r.role}
          href={r.link}
          target="_blank"
          rel="noopener noreferrer"
          title={`${t(`meeting_room_${r.role}`)} · ${r.name || ""}`}
          data-testid={`meeting-room-${r.role}`}
          className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-white text-xs font-semibold transition-colors ${STYLE[r.role] || "bg-slate-800 hover:bg-slate-900"}`}
        >
          <Video className="h-3.5 w-3.5 shrink-0" />
          <span className="hidden lg:inline">{t(`meeting_room_${r.role}`)}</span>
        </a>
      ))}
    </div>
  );
}
